import buttonLoader from '@/components/button/';
import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  mixins: [
    helpers.work_with_date,
  ],
  components: {
    buttonLoader,
  },
  data () {
    return {
      userName: '',
      password: '',
      hidePassword: true,
      message: '',
      keepAlive: false,
      loadingLogin: false,
      load: false,
    };
  },
  computed: {
    passwordType () {
      return this.hidePassword ? 'password' : 'text';
    },
    logoPath() {
      return this.$store.getters.logoChanged ? '/img/sew_logo.jpeg' : '/img/logo-dark.png';
    },
  },
  mounted () {
    this.load = true;
  },
  methods: {

    /**
         * Method for auth user
         */
    login () {
      this.loadingLogin = true;
      this.message = '';

      const params = {
        userlogin: this.userName,
        userpasswd: this.password,
        keepalive: this.keepAlive,
        timezone: this.getTimeZone(),
      };

      Api.auth
        .checkAccountData(params)
        .then((data) => {
          this.loadingLogin = false;

          if (data.data.Status) {
            this.$store.dispatch('AUTH_REQUEST', {
              accessToken: data.data.UserToken,
              refreshToken: data.data.RefreshToken,
            })
              .then(() => {
                this.$router.push({ name: 'welcome_page' });
              });
          } else {
            if (data.data.hasOwnProperty('ConfirmEmail')) {
              this.typeResponse = 'success';
            } else {
              this.typeResponse = 'fail';
            }

            this.message = data.data.Message;
          }
        });
    },
  },
};
